export const vert = /*glsl*/ `
precision lowp float;

uniform sampler2D tEmissiveMap;

uniform mat4 modelMatrix;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

uniform float uOnlyEmissive;

attribute vec3 position;
attribute vec3 normal;
attribute vec2 uv;
attribute vec2 uv2;
attribute vec2 aCustomUv;

varying vec3 vNormal;
varying vec3 vPosition;
varying vec2 vUv;
varying vec2 vUv2;
varying vec2 vCustomUv;
varying float vOnlyEmissive;

void main(){
  vUv = uv;
  vUv2 = uv2;
  vCustomUv = aCustomUv;
  vOnlyEmissive = uOnlyEmissive;

  vPosition = (modelMatrix * vec4(position, 1.)).xyz;
  vNormal = normalize ( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * normal );
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.);
}`;
